<template>
  <div class="s-modal__wrapper s-modal__wrapper--white">
    <!-- Header -->
    <div class="s-modal__header s-modal__header--transparent">
      <span class="s-modal__label--code">
        <p>코드보기</p>
        <p class="s-modal__label--desc">(자바스크립트)</p>
      </span>
      <button id="s-modal-close"
              type="button"
              class="s-modal__btn--close"
              data-dismiss="modal"
              aria-label="Close"
              @click="$emit('closePopup')"></button>
    </div>

    <!-- Main Content -->
    <div class="s-modal__body s-modal__body--code">
      <strong><span class="func">function</span> <span class="var">startCodmos</span>( ) {</strong><br>
      <p v-for="code in data" class="line" v-html="code"></p>
      <strong>}</strong><br><br>
      <strong><span class="var">startCodmos</span>( );</strong>
    </div>
  </div>
</template>

<script>
    export default {
      name: 'modalCodeTemplate',
      props : {
        data: {
          type: Array,
          default: () => []
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/stage/modal/ModalPartialCode.vue